export default __webpack_public_path__ + "static/media/for-writers.fd228af3.png";